module.exports = __webpack_public_path__ + "img/qczd-wx1.53d06112.jpeg";